import { equals } from 'ramda';
import { AttachFileBuilder } from 'reactApp/modules/file/AttachFileBuilder';
import { AnyAction, Reducer } from 'redux';

import { EAttachesFetch, EAttachesFolder, EAttachesFoldersFetch, EAttachesPage, EAttachesViewer } from './attaches.constants';
import { AttachesFolderItem, State } from './attaches.types';

const INITIAL_STATE: State = {
    childs: [],
    attaches: {},
    viewerAttaches: {},
    loadedMessagesIds: [],
    folders: {},
    after: '',
    hasMoreToLoad: false,
    isLoaded: false,
    isLoading: false,
    search: null,
    openedFoldersIdxs: {},
    id: 'attaches',
    allMessagesTotalCount: 0, // число писем по всех папках юзера, включая 'spam', 'drafts', 'templates', 'trash'
};

const attachFileBuilder = new AttachFileBuilder();

export const attachesReducer: Reducer = (state: State = INITIAL_STATE, action: AnyAction): State => {
    switch (action.type) {
        case EAttachesPage.RESET:
            return {
                ...state,
                after: '',
                openedFoldersIdxs: {},
                hasMoreToLoad: false,
            };
        case EAttachesFetch.REQUEST: {
            const { query, type, folderId } = action.payload;
            const search = query || type || folderId ? { query, type, folderId } : null;
            const isNewSearch = !equals(state.search, search);

            return {
                ...state,
                search,
                after: isNewSearch ? '' : state.after,
                childs: isNewSearch ? [] : state.childs,
                isLoaded: false,
                isLoading: true,
            };
        }
        case EAttachesViewer.SAVE: {
            const { attaches, messageId } = action.payload;

            return {
                ...state,
                viewerAttaches: { ...state.viewerAttaches, ...attaches },
                loadedMessagesIds: [...state.loadedMessagesIds, messageId],
            };
        }
        case EAttachesFetch.SUCCESS: {
            const { noOffset, after, attaches, hasMoreToLoad } = action.payload;

            const newAttaches = {
                ...state.attaches,
                ...attaches,
            };
            Object.keys(attaches).forEach((key) => {
                if (state.attaches[key]?.url) {
                    newAttaches[key].url = state.attaches[key].url;
                }

                if (state.attaches[key]?.editors) {
                    newAttaches[key].editors = state.attaches[key].editors;
                }

                if (state.attaches[key]?.attachType) {
                    newAttaches[key].attachType = state.attaches[key].attachType;
                }

                if (state.attaches[key]?.thumbnails) {
                    newAttaches[key].thumbnails = state.attaches[key].thumbnails;
                }
            });

            const childs = Array.from(new Set([...state.childs, ...Object.keys(attaches)]));
            return {
                ...state,
                attaches: newAttaches,
                isLoading: false,
                isLoaded: true,
                childs,
                after: noOffset ? state.after : after,
                hasMoreToLoad: hasMoreToLoad ?? state.hasMoreToLoad,
            };
        }
        case EAttachesFoldersFetch.SUCCESS: {
            const allMessagesTotalCount =
                action.payload?.reduce((count, folder: AttachesFolderItem) => count + folder.messages_total, 0) ??
                state.allMessagesTotalCount;

            const newItems = action.payload
                ? action.payload
                      .filter((folder: AttachesFolderItem): any => !['spam', 'drafts', 'templates', 'trash'].includes(folder.type))
                      .reduce(
                          (acc, item): Record<string, AttachesFolderItem> => ({
                              ...acc,
                              [item.id]: attachFileBuilder.buildFolderItem(item),
                          }),
                          {}
                      )
                : {};
            const folders = {
                ...state.folders,
                ...newItems,
            };
            return {
                ...state,
                folders,
                allMessagesTotalCount,
            };
        }
        case EAttachesFolder.TOGGLE: {
            const { [action.payload.id]: prevValue, ...rest } = state.openedFoldersIdxs;
            return {
                ...state,
                openedFoldersIdxs: {
                    ...rest,
                    [action.payload.id]: !prevValue,
                },
            };
        }
        default:
            return state;
    }
};
